'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

exports.__esModule = true;
exports.default = void 0;

var _createWithBsPrefix = _interopRequireDefault(require('./utils/createWithBsPrefix'));

var _default = (0, _createWithBsPrefix.default)('card-deck');

exports.default = _default;
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./app/praece-react-bootstrap/lib/CardDeck.js